const common = {
     computed: {
    ...mapState([
      "notification",
      "session", 
      "hideSubMenu",
      "selected_object",
      "selected_group"
    ]),
  }, 
    data() {
        return {
            search: '',
            loader: false,
            numRules: [value => !isNaN(parseFloat(value)) || "This field is required."],
            requiredRules: [value => !!value || "This field is required."],
            phoneRules: [
                v => !!v || "Phone number is required.",
                v =>
                    /^(0)([0-9]{9})$/.test(v) ||
                    "Phone number format should be: 0xxxxxxxxx"
            ],
            dateRules: [
                v => !!v || "Date is required."
            ],
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid"
            ],
            uploadRules: [
                v => !!v || this.iseditmode ? true : "Upload is required.",
            ],
            custom_notification: []
        }
    },
    methods: {
        ...mapMutations(["SET_NOTIFICATION"]), 
        ...mapActions([ 
            "logout", 
            "select_object", 
            "select_active_group",
            "reset_selected_object"
        ]),
        setNotification(t, m) {
            this.custom_notification["msg"] = m;
            this.custom_notification["type"] = t;
            this.$store.commit("SET_NOTIFICATION", this.custom_notification);
        },

        applySearch(imei){  
            if(imei!=''){  
                let obj = this.drpObjectsOnly.find(o => o.imei === imei); 
                this.asset_groups.find(g => g.text === obj.group_name).model = true; 
                let selected_local = []; 
                selected_local.push(imei); 

                this.$store.dispatch("select_object", selected_local); 
                this.$store.dispatch("select_active_group",obj.group_name);  
            }  else {
                this.$store.dispatch("reset_selected_object", imei); 
            }
        },

        http_connect(endpoint, payload, config = {}) {
            this.loader = true;  
            return this.$http
                .post(endpoint, payload, {
                    ...config,
                    headers: {
                        'Content-Type': 'application/json',
                        ...(config.headers || {})
                    }
                }) 
                .then(res => { 
                    this.loader = false; 
                    return res;
                })
                .catch(err => {  
                        
                    if(err.toString().includes("Error: Request failed with status code 401")){
                        this.setNotification(
                            "error",
                            "Sorry your session has expired, please log in again."
                        );
                        this.$store.dispatch("logout");
                        return {
                            state: 401,
                            payload: "Sorry your session has expired, please log in again."
                        }
                    } 

                    this.loader = false;
                    this.setNotification(
                        "error",
                        "Failed to make request. Ensure you have internet connection and try again."
                    );

                    return {
                        state: 500,
                        payload: "Failed to make request. Ensure you have internet connection and try again."
                    }
                });
        },

        // Route a call to the Node tracking API. Falls back to the default (PHP)
        // base URL when VUE_APP_NODE_TRACKING_URL is not configured.
        http_connect_node(endpoint, payload) {
            const base = process.env.VUE_APP_NODE_TRACKING_URL;
            return this.http_connect(endpoint, payload, base ? { baseURL: base } : {});
        },

        http_connect_get(endpoint, payload) {
            this.loader = true;
            return this.$http
                .get(endpoint, {params: payload})
                .then(res => {  
                    this.loader = false;
                    
                    
                    return res;
                })
                .catch(err => { 
                    this.loader = false; 
                     
                    if(err.toString().includes("Error: Request failed with status code 401")){
                        this.setNotification(
                            "error",
                            "Sorry your session has expired, please log in again."
                        );
                        this.$store.dispatch("logout");
                    } else {
                        this.setNotification(
                            "error",
                            "Failed to make request. Ensure you have internet connection and try again."
                        );
                    } 
                    return err;
                });
        },

        check_token(){
            var token = '';
            var tk =  localStorage.getItem('vuex');  
            if(tk!=null){  
                token =JSON.parse(tk).session.token
            }
            return token;
        }
    },
    computed: {
        ...mapState(["notification", "session"]),
       
        // objectsOnly
    }
}

import { mapMutations, mapState, mapActions} from "vuex";
import moment from "moment";
export default common;